export const AUTH_ROUTES = [
  'Login',
  'Login.en',
  'Register',
  'Register.en',
  'ForgotPassword',
  'ResetPassword',
  'OAuthCallback',
  'ConfirmEmail',
]

export function isAuthRouteName(name) {
  return AUTH_ROUTES.includes(name?.toString() || '')
}

// Filters a redirect-query-param path so it never points back at an auth page —
// otherwise "Sign in" links built from route.fullPath on the login page itself
// would nest indefinitely: /autentificare?redirect=/autentificare?redirect=/... (#565)
export function safeRedirect(router, path) {
  if (!path) return null
  return isAuthRouteName(router.resolve(path).name) ? null : path
}
